import { formatOrigemParts, formatDestinoParts, formatDateAndRemaining, verificaAtrasoPrevisao } from "@spark/services";
import React from 'react';
import TableBadge from '@spark/ui-components/components/TanStackTable/components/TableBadge';
import TruncatedText from '@spark/ui-components/components/TanStackTable/components/TruncatedText';
import Icon from '@spark/ui-components/components/Icon';
/**
 * Função para obter cores dos badges baseada no status
 */

const getStatusBadgeVariant = dataPrevisaoChegadaDestino => {
  const status = verificaAtrasoPrevisao(dataPrevisaoChegadaDestino);
  return status.color === "warning" ? "danger" : "success";
};
/**
 * Colunas da tabela de previsão de cargas usando TanStack Table
 */


export const getPrevisaoCargasColumns = () => [{
  id: 'veiculo',
  header: 'CAMINHÃO',
  accessorKey: 'veiculo.frota',
  size: 220,
  enableSorting: true,
  cell: ({
    getValue,
    row
  }) => {
    const frota = getValue();
    const veiculo = row.original.veiculo;
    return <div>
          <div style={{
        fontWeight: '500',
        fontSize: '1.1rem'
      }}>
            {frota || "Local não informado"}
          </div>
          {veiculo?.placa && <div style={{
        color: '#666',
        fontSize: '0.8rem'
      }}>
              {veiculo.placa}
            </div>}
        
        </div>;
  }
}, {
  id: 'origem',
  header: 'ORIGEM',
  accessorKey: 'enderecoClienteOrigem',
  size: 220,
  enableSorting: true,
  cell: ({
    row
  }) => {
    const origemParts = formatOrigemParts(row.original.enderecoClienteOrigem, row.original.clienteOrigem);
    return <div>
          <div style={{
        fontWeight: '500',
        fontSize: '1.1rem'
      }}>
            {origemParts.main || "Local não informado"}
          </div>
          {origemParts.subtitle && <div style={{
        color: '#666',
        fontSize: '0.8rem'
      }}>
              {origemParts.subtitle}
            </div>}
        
          {origemParts.cliente && <div style={{
        color: '#007bff',
        fontSize: '0.8rem',
        fontWeight: '500',
        marginTop: '4px'
      }}>
          
              {origemParts.cliente}
            </div>}
        
        </div>;
  }
}, {
  id: 'seta',
  header: '',
  accessorKey: 'seta',
  size: 60,
  enableSorting: false,
  cell: () => <div className="text-center">
        <Icon name="arrow-right" size={18} />
      </div>
}, {
  id: 'destino',
  header: 'DESTINO',
  accessorKey: 'enderecoClienteDestino',
  size: 220,
  enableSorting: true,
  cell: ({
    row
  }) => {
    const destinoParts = formatDestinoParts(row.original.enderecoClienteDestino, row.original.clienteDestino);
    return <div>
          <div style={{
        fontWeight: '500',
        fontSize: '1.1rem'
      }}>
            {destinoParts.main || "Local não informado"}
          </div>
          {destinoParts.subtitle && <div style={{
        color: '#666',
        fontSize: '0.8rem'
      }}>
              {destinoParts.subtitle}
            </div>}
        
          {destinoParts.cliente && <div style={{
        color: '#007bff',
        fontSize: '0.8rem',
        fontWeight: '500',
        marginTop: '4px'
      }}>
          
              {destinoParts.cliente}
            </div>}
        
        </div>;
  }
}, {
  id: 'horario',
  header: 'HORÁRIO',
  accessorKey: 'dataPrevisaoChegadaDestino',
  size: 180,
  enableSorting: true,
  cell: ({
    row
  }) => {
    const previsaoParts = formatDateAndRemaining(row.original.dataPrevisaoChegadaDestino, row.original.previsibilidade);
    return <div>
          <div style={{
        fontWeight: '500',
        fontSize: '1.1rem'
      }}>
            {previsaoParts.main}
          </div>
          {previsaoParts.subtitle && <div style={{
        color: '#666',
        fontSize: '0.8rem',
        marginTop: '4px'
      }}>
          
              {previsaoParts.subtitle}
            </div>}
        
        </div>;
  }
}, {
  id: 'status',
  header: 'STATUS',
  accessorKey: 'dataPrevisaoChegadaDestino',
  size: 120,
  enableSorting: true,
  cell: ({
    getValue
  }) => {
    const status = verificaAtrasoPrevisao(getValue());
    return <TableBadge variant={getStatusBadgeVariant(getValue())} label={status.label.toUpperCase()} />;
  }
}];
